export const byUserIdSelector = ({ persistedData: { byUserId } }) => {
  return byUserId;
};
